import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const ProfileLink = ({ isSmallScreen }: Props) => {
	return (
		<StyledNavLink to="/account/profile" title="Profile" isSmallScreen={isSmallScreen}>
			Go to my Profile
		</StyledNavLink>
	);
};

export default ProfileLink;

interface Props {
	isSmallScreen: boolean;
}

const StyledNavLink = styled(NavLink)<{ isSmallScreen: boolean }>`
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '12px' : '14px')};
	color: ${({ theme }) => theme.colors.white};
	text-decoration: underline;
`;
